<template>
  <v-sheet tag="section" class="mb-md-15">
    <v-row class="form-item-heading" :class="headingBgColor">
      <v-subheader class="text-subtitle-1 align-center" :class="[headingTextColor ? `${headingTextColor}--text` : null, headingPadding, {'font-weight-bold': isHeadingTextBold}]">
        <slot v-if="this.$scopedSlots.title" name="title" />
        <template v-else>{{this.getTitleLabel}}状況</template>
      </v-subheader>
    </v-row>
    <v-row>
      <v-col>
        <v-stepper
            v-model="currentStep"
            class=""
            flat
            evelation="0"
            color="transparent"
            :alt-labels="true"
        >
          <v-stepper-header class="unset-box-shadow">
            <v-stepper-step :complete="currentStep > 1" step="1" :class="!$vuetify.breakpoint.mdAndUp ? 'text-body-2' : ''">
              お申込み{{stepperLabelSeparator}}梱包
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" step="2" :class="!$vuetify.breakpoint.mdAndUp ? 'text-body-2' : ''">
              商品到着{{stepperLabelSeparator}}査定
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 3" step="3" :class="!$vuetify.breakpoint.mdAndUp ? 'text-body-2' : ''">
              査定結果<br v-if="!$vuetify.breakpoint.mdAndUp">報告
            </v-stepper-step>
            <template v-if="!isCharibon">
              <v-divider></v-divider>
              <v-stepper-step :complete="currentStep > 4" step="4" :class="!$vuetify.breakpoint.mdAndUp ? 'text-body-2' : ''">
                {{ this.finalStepHeader}}
              </v-stepper-step>
            </template>
          </v-stepper-header>
          <v-divider class="my-4" />
          <v-row no-gutters dense>
            <v-col cols="12" md="6">お申し込み日：{{ stateItems.dateOfApplication }}</v-col>
            <v-col cols="12" md="6" class="text-md-right">買取ナンバー：{{this.getFormItems.buyNumber}}</v-col>
          </v-row>
          <v-divider class="my-4" />
          <v-stepper-items>
            <v-stepper-content step="1" class="pa-0" :class="!$vuetify.breakpoint.mdAndUp ? 'px-0' : ''">
              <!-- FIXME: 中身部品化-->
              <v-list>
                <v-list-item :class="[{ 'pa-4': isCharibon, 'pa-0': !isCharibon }, { 'pr-0': !$vuetify.breakpoint.mdAndUp }]">
                  <v-list-item-content>
                    <v-list-item-title class="text-body-1 headline-text">【{{ stateItems.dateOfApplication }}】{{this.getTitleLabel}}依頼を承りました。</v-list-item-title>
                    <v-list-item-title class="text-body-1 headline-text" >集荷予定日までに商品の梱包をお願いいたします。</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-card
                class="d-flex flex-wrap mt-11 mb-12"
                min-height="200px"
                flat
              >
                <v-card-title class="text-body-1 pa-0 mb-2" style="flex: 0 0 100%;">お申込み内容</v-card-title>
                <v-card-text class="pa-8" style="flex: 1;" :style="isCharibon ? 'background-color: #fff;' : 'background-color: #f5f5f5;'">
                  <v-row no-gutters dense style="color: #2c2c2c">
                    <template v-if="isCharibon">
                      <v-col class="mb-2 mb-md-3" cols="12" md="3">支援先</v-col>
                      <v-col class="mb-8 mb-md-0 pl-0 pl-md-5 font-weight-bold" cols="12" md="9">{{ stateItems.supportGroupName }}</v-col>
                    </template>
                    <v-col class="mb-2 mb-md-3" cols="12" md="3">集荷予定日</v-col>
                    <v-col class="mb-8 mb-md-0 pl-0 pl-md-5 font-weight-bold" cols="12" md="9">{{ pickUpDayForDisplay }}</v-col>
                    <v-col class="mb-2 mb-md-3" cols="12" md="3">集荷予定箱数</v-col>
                    <v-col class="mb-8 mb-md-0 pl-0 pl-md-5 font-weight-bold" cols="12" md="9">{{ stateItems.numberOfPackages }}箱</v-col>
                    <v-col cols="12" md="3">適用中のクーポン</v-col>
                    <v-col class="pl-0 pl-md-5 font-weight-bold" cols="12" md="9">
                      {{ buyFormItems.campaignCode ? `${buyFormItems.campaignCode}（${buyFormLabels.campaignName}）` : 'なし' }}
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions v-if="isValueBooks" class="pr-0 pr-md-8" style="flex: 0 0 auto;background-color: #f5f5f5" :style="!$vuetify.breakpoint.mdAndUp ? 'width:100%;' : null">
                  <v-btn color="black" class="mx-auto mb-6 mb-md-0" @click="$router.push({name:'UpdateApplicationInformation'})">
                    <span class="text-caption white--text">お申込み後の変更はこちらから</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2" class="pa-0">
              <v-card
                  class="mb-12"
                  min-height="200px"
                  flat
              >
                <v-list>
                  <template v-if="isCharibon">
                    <v-subheader>支援先</v-subheader>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-icon class="mr-4">
                        <v-icon>mdi-send</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">{{ stateItems.supportGroupName }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <v-subheader>商品到着日</v-subheader>
                  <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                    <v-list-item-icon class="mr-4">
                      <v-icon>mdi-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-1 headline-text">
                        {{ stateItems.dateOfChangeApplicationState }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-content class="pl-4">
                      <v-list-item-title class="text-body-1 headline-text mb-2">商品が買取センターに到着いたしました。</v-list-item-title>
                      <v-list-item-title class="text-body-1 headline-text" >査定結果のご報告まで、お待ち下さい。</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3" class="pa-0">
              <v-card
                  class="mb-12"
                  min-height="200px"
                  flat
              >
                <v-list>
                  <template v-if="isCharibon">
                    <v-subheader>支援先</v-subheader>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-icon class="mr-4">
                        <v-icon>mdi-send</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">{{ stateItems.supportGroupName }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                    <v-list-item-content>
                      <v-list-item-title class="text-body-1 headline-text">査定が完了しました。</v-list-item-title>
                      <v-list-item-title v-if="isCharibon" class="text-body-1 headline-text" >ご利用ありがとうございました。またのご利用をおまちしております。</v-list-item-title>
                      <v-list-item-title v-else class="text-body-1 headline-text">査定結果を確認し、お取引の選択をお願いします。</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-subheader>査定内容</v-subheader>
                  <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                    <v-list-item-content>
                      <v-list-item-title class="text-body-1 headline-text">査定点数</v-list-item-title>
                      <v-list-item-subtitle class="text-body-1 headline-text">{{
                          stateItems.totalCount | addCommaSeparator
                        }}冊
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-1 headline-text">買取点数</v-list-item-title>
                      <v-list-item-subtitle class="text-body-1 headline-text">{{
                          stateItems.okCount | addCommaSeparator
                        }}冊
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-1 headline-text">{{ this.getAmountLabel }}</v-list-item-title>
                      <v-list-item-subtitle class="text-body-1 headline-text">
                        {{ stateItems.gTotalInput | addCommaSeparator }}円
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-btn
                  v-if="isCharibon || isValueBooks"
                  class="d-flex white--text text-subtitle-1 mx-auto mt-6"
                  :class="isCharibon ? 'secondary' : null"
                  :color="isValueBooks ? '#0095d9' : null"
                  max-width="320"
                  width="100%"
                  height="60"
                  @click="dispAssessItems = true;"
                  elevation="0"
                >
                  {{ isCharibon ? '買取の明細を確認する' : '査定結果を確認する' }}
                </v-btn>
              </v-card>

              <!-- Vabooの場合のみ表示 -->
              <template v-if="isVaboo">
                <v-divider></v-divider>
                <v-radio-group
                    v-model="executableRadio"
                    class="px-2"
                >
                  <v-radio
                      v-if="isBuyPriceGreaterZero"
                      :value="1"
                      key="1"
                      class="mb-5"
                      :color="isValueBooks ? '#0095d9' : null"
                  >
                    <template v-slot:label>
                      <v-row class="mt-0">
                        <v-col class="col-6 col-md-3 pt-0 grey--text text--darken-4">銀行振込</v-col>
                        <v-col class="col-6 col-md-2 pt-0 text-right grey--text text--darken-4">{{ stateItems.gTotalInput | addCommaSeparator }} 円</v-col>
                      </v-row>
                    </template>
                  </v-radio>
                  <v-radio
                      v-else
                      :value="1"
                      key="1"
                      class="mb-5"
                      :color="isValueBooks ? '#0095d9' : null"
                  >
                    <template v-slot:label>
                      <v-row class="mt-0">
                        <v-col class="col-6 col-md-3 pt-0 grey--text text--darken-4">弊社での引受</v-col>
                      </v-row>
                    </template>
                  </v-radio>
                  <v-radio
                      :value="2"
                      key="2"
                      class="mb-5"
                  >
                    <template v-slot:label>
                      <v-row class="mt-0">
                        <v-col class="col-6 col-md-3 pt-0 grey--text text--darken-4">キャンセルして返送</v-col>
                        <v-col class="col-6 col-md-2 pt-0 text-right grey--text text--darken-4">0 円</v-col>
                      </v-row>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-btn
                      @click="executableRadioModal"
                      :color="isValueBooks ? '#0095d9' : 'primary'"
                      :class="isValueBooks ? 'white--text' : null"
                >
                  確定する
                </v-btn>
              </template>

              <!-- FIXME: コンポーネント化-->
              <v-dialog v-model="dispAssessItems"
                        :fullscreen="$vuetify.breakpoint.smAndDown"
                        :width="$vuetify.breakpoint.mdAndDown? '100%': '100%'"
                        style="z-index: 9999"
              >
                <v-card>
                  <assess-items
                    :heading-bg-color="headingBgColor"
                    :heading-text-color="headingTextColor"
                    :heading-padding="headingPadding"
                    :data="stateItems.assessItems">
                  </assess-items>
                  <v-card-actions class="justify-space-around pb-6">
                    <v-btn @click="dispAssessItems = false">閉じる</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogBankTransfer"
                        :fullscreen="!isValueBooks && $vuetify.breakpoint.smAndDown"
                        :width="$vuetify.breakpoint.smAndDown? '100%': '640px'"
                        style="z-index: 9999"
              >
                <v-card>
                  <v-card-title class="lighten-2 justify-center" :class="$vuetify.breakpoint.smAndDown ? 'mb-4' : 'my-4'">
                    銀行振込
                  </v-card-title>
                  <v-card-subtitle>以下をご確認の上、お手続きを行ってください。</v-card-subtitle>
                  <v-card-text class="justify-center" :style="$vuetify.breakpoint.mdAndUp ? 'line-height:1.75rem;' : 'line-height:2rem;'">
                    <ul style="list-style:unset;">
                      <li style="line-height:1.375rem;">お値段をお付けできなかったもの及び査定できなかった商品の返送はできません。</li>
                      <li class="red--text font-weight-bold">この処理は変更はできません。</li>
                    </ul>
                  </v-card-text>
                  <v-card-subtitle>お振込みの手続きに進みます。よろしいですか？</v-card-subtitle>
                  <v-divider></v-divider>

                  <v-card-actions class="justify-space-around pb-6">
                    <v-btn :color="isValueBooks ? '#0095d9' : 'primary'"
                           :class="[{ 'white--text': isValueBooks }]"
                           @click="dialogBankTransfer = false; updateOfferState(1)">OK
                    </v-btn>
                    <v-btn @click="dialogBankTransfer = false">閉じる</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogUndertakeFree"
                        :fullscreen="!isValueBooks && $vuetify.breakpoint.smAndDown"
                        :width="$vuetify.breakpoint.smAndDown? '100%': '600px'"
                        style="z-index: 9999"
              >
                <v-card>
                  <v-card-title class="lighten-2 justify-center" :class="$vuetify.breakpoint.smAndDown ? 'mb-4' : 'my-4'">
                    弊社引き受け
                  </v-card-title>
                  <v-card-text class="justify-center">
                    弊社引き受けのお手続きをさせていただきます。<br>
                    この処理は変更することができません。よろしいですか？
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-space-around pb-6">
                    <v-btn :color="isValueBooks ? '#0095d9' : 'primary'"
                           :class="[{ 'white--text': isValueBooks }]"
                           @click="dialogUndertakeFree = false; updateOfferState(3)">OK
                    </v-btn>
                    <v-btn @click="dialogUndertakeFree = false">閉じる</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogNoOffer"
                        :fullscreen="!isValueBooks && $vuetify.breakpoint.smAndDown"
                        :width="$vuetify.breakpoint.smAndDown? '100%': '640px'"
                        style="z-index: 9999"
              >
                <v-card>
                  <v-card-title class="lighten-2 justify-center" :class="$vuetify.breakpoint.smAndDown ? 'mb-4' : 'my-4'">
                    返送
                  </v-card-title>
                  <v-card-subtitle>以下をご確認の上、お手続きを行ってください。</v-card-subtitle>
                  <v-card-text class="justify-center" :style="$vuetify.breakpoint.mdAndUp ? 'line-height:1.75rem;' : 'line-height:2rem;'">
                    <ul style="list-style:unset;">
                      <li>返送時の送料はいただきません。</li>
                      <li class="red--text font-weight-bold">この処理は変更はできません。</li>
                    </ul>
                  </v-card-text>
                  <v-card-subtitle>返送の手続きに進みます。よろしいですか？</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-space-around pb-6">
                    <v-btn :color="isValueBooks ? '#0095d9' : 'primary'"
                           :class="[{ 'white--text': isValueBooks }]"
                           @click="dialogNoOffer = false; updateOfferState(2)">OK</v-btn>
                    <v-btn @click="dialogNoOffer = false">閉じる</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogError"
                        :fullscreen="!isValueBooks && $vuetify.breakpoint.smAndDown"
                        :width="$vuetify.breakpoint.smAndDown? '100%': '600px'"
                        style="z-index: 9999"
              >
                <v-card>
                  <v-card-title></v-card-title>
                  <v-card-text class="justify-center">
                    処理に失敗しました。<br>
                    お手数ですが、時間を置いて再度お試しください。
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn @click="dialogError = false">閉じる</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-stepper-content>
            <v-stepper-content step="4" class="pa-0">
              <v-card
                  class="mb-12"
                  min-height="200px"
                  flat
              >
                <v-list>
                  <template v-if="stateItems.customerStatusCode === 'E01'">
                    <v-subheader>返送ご依頼日</v-subheader>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-icon class="mr-4">
                        <v-icon>mdi-clock</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">
                          {{ stateItems.dateOfChangeApplicationState }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-subheader>返送</v-subheader>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">返送点数</v-list-item-title>
                        <v-list-item-subtitle class="text-body-1 headline-text">{{
                            stateItems.totalCount
                          }}冊
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">返送のお手続きを取らせて頂きます。</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-else-if="stateItems.customerStatusCode === 'F01'">
                    <v-subheader>返送ご依頼日</v-subheader>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-icon class="mr-4">
                        <v-icon>mdi-clock</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">
                          {{ stateItems.dateOfChangeApplicationState }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-subheader>返送</v-subheader>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">返送のお手続きを完了しました。</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-else-if="stateItems.customerStatusCode === 'X01'">
                    <template v-if="stateItems.cancelReasonCode === 'A' || stateItems.cancelReasonCode === 'B' || stateItems.cancelReasonCode === 'C'">
                      <v-subheader>お取引完了日</v-subheader>
                      <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                        <v-list-item-icon class="mr-4">
                          <v-icon>mdi-clock</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="text-body-1 headline-text">
                            {{ stateItems.dateOfEndBuyState }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-subheader>買取内容</v-subheader>
                      <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                        <v-list-item-content>
                          <v-list-item-title class="text-body-1 headline-text">査定点数</v-list-item-title>
                          <v-list-item-subtitle class="text-body-1 headline-text">{{
                              stateItems.totalCount
                            }}冊
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content>
                          <v-list-item-title class="text-body-1 headline-text">買取点数</v-list-item-title>
                          <v-list-item-subtitle class="text-body-1 headline-text">{{
                              stateItems.okCount
                            }}冊
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content>
                          <v-list-item-title class="text-body-1 headline-text">金額</v-list-item-title>
                          <v-list-item-subtitle class="text-body-1 headline-text">
                            {{ stateItems.gTotalInput | addCommaSeparator }}円
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                        <v-list-item-content>
                          <v-list-item-title class="text-body-1 headline-text">ご回答いただけなかったため、弊社規約の通り、期限切れとして処理させて頂きました。<br>この件に関しましては、直接、カスタマーセンターへ<a :href="isValueBooks ? '/inquiry' : '/form/vb-inquiry'">お問合せ</a>ください。</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-else>
                      <v-subheader>お取引完了日</v-subheader>
                      <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                        <v-list-item-icon class="mr-4">
                          <v-icon>mdi-clock</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="text-body-1 headline-text">
                            {{ stateItems.dateOfEndBuyState }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                        <v-list-item-content>
                          <v-list-item-title class="text-body-1 headline-text">お取引をキャンセルしました。</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </template>
                  <template v-else-if="stateItems.customerStatusCode === 'D01'">
                    <template v-if="isBuyPriceGreaterZero">
                      <template v-if="isBuyStateMessage">
                        <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 headline-text">{{ stateItems.buyStateNoticeMessage}}</v-list-item-title>
                            <v-list-item-title class="text-body-1 headline-text">{{ stateItems.buyStateErrorMessage}}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-else-if="stateItems.stateOfBuy !== '3'">
                        <v-subheader>お振込ご依頼日</v-subheader>
                        <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                          <v-list-item-icon class="mr-4">
                            <v-icon>mdi-clock</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 headline-text">
                              {{ stateItems.dateOfChangeApplicationState }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 headline-text">お振込み手続きをさせていただきます。</v-list-item-title>
                            <v-list-item-title class="text-body-1 headline-text" >ご指定の金融機関の3～5営業日以内にお振込みいたします。</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-else>
                        <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 headline-text">お振込み手続きは完了しています。</v-list-item-title>
                            <v-list-item-title class="text-body-1 headline-text" >この度は、ありがとうございました。またのご利用をおまちしております。</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="stateItems.stateOfBuy !== '3'">
                        <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 headline-text">弊社引き受けの手続きを行わせて頂きます。</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-else>
                        <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 headline-text">弊社引き受けのお手続きを行いました。</v-list-item-title>
                            <v-list-item-title class="text-body-1 headline-text" >ご利用ありがとうございました。またのご利用をおまちしております。</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </template>
                    <v-subheader>買取内容</v-subheader>
                    <v-list-item :class="!$vuetify.breakpoint.mdAndUp ? 'pr-0' : ''">
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">査定点数</v-list-item-title>
                        <v-list-item-subtitle class="text-body-1 headline-text">{{
                            stateItems.totalCount
                          }}冊
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">買取点数</v-list-item-title>
                        <v-list-item-subtitle class="text-body-1 headline-text">{{
                            stateItems.okCount
                          }}冊
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-1 headline-text">{{ this.getAmountLabel }}</v-list-item-title>
                        <v-list-item-subtitle class="text-body-1 headline-text">
                          {{ stateItems.gTotalInput | addCommaSeparator }}円
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-sheet>

</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import AssessItems from './assess-items.vue';

export default {
  name: "buy-status",
  components: {
    AssessItems
  },
  provide() {
    return {
      stateItems: this.stateItems,
      isBuyPriceGreaterZero: this.isBuyPriceGreaterZero,
      isValueBooks: this.isValueBooks,
      executableRadioModal: this.executableRadioModal,
    }
  },
  props: {
    isConfirm: {type: Boolean, default: false},
    headingBgColor: {type: String, default: null},
    headingTextColor: {type: String, default: null},
    headingPadding: {type: String, default: null},
    isHeadingTextBold: {type: Boolean, default: false},
  },
  data() {
    return {
      dialogNoOffer: false,
      dialogBankTransfer: false,
      dialogUndertakeFree: false,
      dialogError: false,
      dispAssessItems: false,
      finalStepHeader: "お振込",
      stateUpdateMessage:[
        {
          "subtitle": "お振込み",
          "message": "お取引が完了しました。お振込みの手続きが完了しましたら、ご連絡いたします。"
        },
        {
          "subtitle": "返送",
          "message": "お取引が完了しました。返送の手続きを取らせて頂きます。"
        },
        {
          "subtitle": "弊社引き受け",
          "message": "お取引が完了しました。弊社引き受けの手続きを取らせて頂きます。"
        },
        {
          "subtitle": "お振込み",
          "message": "ご回答ありがとうございます。口座登録、身分証登録の状態をご確認ください。"
        },
      ],
    }
  },
  computed: {
    ...mapGetters('buyState', [
      'getFormItems', 'getFormLabels'
    ]),
    ...mapGetters('buy',
      {'buyFormItems': 'getFormItems', 'buyFormLabels': 'getFormLabels'}
    ),
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
    isVaboo() {
      return this.$siteCode === VueConfig.siteCode.vaboo;
    },
    isValueBooks() {
      return this.$siteCode === VueConfig.siteCode.valuebooks;
    },
    getTitleLabel() {
      return this.isCharibon ? "お申込み" : "買取";
    },
    getAmountLabel() {
      return this.isCharibon ? "寄付金額" : "お振込み金額";
    },
    stateItems() {
      return this.getFormLabels;
    },
    currentStep() {
      let step = 1;
      if (this.isCharibon) {
        switch (this.stateItems.customerStatusCode) {
          case "A01":
            step = 1;
            break
          case "B01":
            step = 2;
            break
          case "X01":
            this.finalStepHeader = !this.$vuetify.breakpoint.mdAndUp ? "取引\nキャンセル" : "取引キャンセル"
            step = 4;
            break
          default:
            step = 3;
            break
        }
      } else {
        switch (this.stateItems.customerStatusCode) {
          case "A01":
            step = 1;
            break
          case "B01":
            step = 2;
            break
          case "C01":
            step = 3;
            break
          case "D01":
            this.finalStepHeader = this.isBuyPriceGreaterZero? "お振込": "弊社引き受け"
            step = 4;
            break
          case "E01":
            this.finalStepHeader = "返送手続き"
            step = 4;
            break
          case "F01":
            this.finalStepHeader = "返送完了"
            step = 4;
            break
          case "X01":
            this.finalStepHeader = !this.$vuetify.breakpoint.mdAndUp ? "取引\nキャンセル" : "取引キャンセル"
            step = 4;
            break
          default:
            step = 0;
            break
        }
      }
      this.buyState = step
      return step;
    },
    pickUpDayForDisplay() {
      return this.stateItems.pickupDate + this.stateItems.pickupPeriodName
    },
    dateOfChangeApplicationStateForDisplay() {
      return this.convertedToDateStringForDisplay(this.stateItems.dateOfChangeApplicationState)
    },
    isBuyPriceGreaterZero(){
      return this.stateItems.gTotalInput > 0
    },
    isBuyStateMessage(){
      return this.stateItems.buyStateNoticeMessage || this.stateItems.buyStateErrorMessage
    },
    stepperLabelSeparator() {
      return this.$vuetify.breakpoint.mdAndUp ? "・" : "\n";
    },
    executableRadio: {
      get() {
        return this.stateItems.assessmentResultAnswerValue
      },
      set(value) {
        this.setAssessmentResultAnswerValue(value);
      }
    }
  },
  methods: {
    // 買取の状態を更新
    async updateOfferState(offer_result) {
      if (this.isCharibon) {
        return;
      }

      // offer_result APIの引数となる 1:銀行振込 2:返送 3:弊社引き受け
      const buyNumber = this.getFormItems.buyNumber;
      const response = await axios.post("/api/vaboo/offer/state/" + buyNumber, {
        torihiki_kekka: offer_result,
        site_code: this.$siteCode
      }).catch((err) => {
        console.error("Catch" + err);
        this.dialogError = true;
        return false;
      });
      if (response.data.result) {
        await this.$emit("getAllState"); // すべての情報を再取得
        let subtitle = this.stateUpdateMessage[offer_result - 1].subtitle
        let message = this.stateUpdateMessage[offer_result - 1].message
        // 不備ありの場合のメッセージをセット
        if(this.stateItems.isBuyStateWrong){
          subtitle = this.stateUpdateMessage[3].subtitle
          message = this.stateUpdateMessage[3].message
        }

        this.$router.push({
          name: "BuyStatusMessageCard",
          params: {
            backGroundColor: "accent2",
            title: "買取状況",
            subtitle: subtitle,
            text: message,
          }
        });
      } else {
        this.dialogError = true;
      }
    },
    executableRadioModal(){
      switch (this.executableRadio) {
        case 1:
          this.isBuyPriceGreaterZero ? this.dialogBankTransfer = true : this.dialogUndertakeFree = true
          break
        case 2:
          this.dialogNoOffer = true
          break
        default:
          break
      }
    },
    ...mapMutations('buyState', ['setAssessmentResultAnswerValue']),
  }
}
</script>

<style scoped lang="scss">
.unset-box-shadow {
  box-shadow: unset !important;
}

.headline-text {
  text-overflow: inherit;
  white-space: unset;
}
::v-deep {
  .v-stepper {
    &__header {
      margin: unset;
    }
    &__label {
      font-size: 14px;
      overflow-wrap: break-word;
      word-break: keep-all;
      line-height: 1.2em;
    }
  }
  .v-stepper__step--complete{
    .v-stepper__step__step{
      border-color: rgba(0, 0, 0, 0.38);
      background-color: rgba(0, 0, 0, 0.38);
    }
    .v-stepper__label {
      color: rgba(0, 0, 0, 0.38);
    }
  }
}
@media screen and (max-width: $breakpoint-md) {
  ::v-deep {
    .v-stepper {
      &__header {
        margin: 0 -15%;
      }
    }
    .v-stepper__label {
      display: flex !important;
      max-width: 76px;
      padding: 4px 8px;
      font-size: 12px !important;
      text-align: center !important;
    }
  }
}
</style>